"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pastorano": {
    "58189445": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "skipSearch": false
    }],
    "pantuliano": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc07b7b0": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "skipSearch": false
    }],
    "pigna": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "617cd476": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "skipSearch": false
    }],
    "san-secondino": [{
      "hkey": "5ef423b4",
      "slug": "pastorano",
      "name": "Pastorano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;